import { Component, DestroyRef, NgZone, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { DialogService, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';

import { LoaderService } from './core/service/loader.service';
import { messaging } from '../configs/firebase.config';
import { NotificationPayload } from './shared/models/INotification';
import { ToastService } from './core/service/toast.service';
import { OrderNotifyModalComponent } from './shared/components/order-notify-modal/order-notify-modal.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, DynamicDialogModule, ProgressBarModule, ProgressSpinnerModule, ToastModule],
  providers: [DialogService],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  private readonly primengConfig = inject(PrimeNGConfig);
  readonly loaderService = inject(LoaderService);
  private readonly toastService = inject(ToastService);
  private readonly zone = inject(NgZone);
  private readonly dialogService = inject(DialogService);
  private readonly destroyRef = inject(DestroyRef);

  loaderState = false;
  ref: DynamicDialogRef | undefined;

  ngOnInit(): void {
    this.loaderService
      .getLoaderState()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (state) => {
          this.loaderState = state;
        },
      });
    this.primengConfig.ripple = true;
    this.listen();
  }

  listen(): void {
    messaging.onMessage((incomingMessage: NotificationPayload) => {
      this.zone.run(() => {
        this.toastService.showSuccess(incomingMessage.notification.title, incomingMessage.notification.body);
        if (incomingMessage.data.type === 'order') {
          this.openOrderNotifyModal({ ...incomingMessage.notification, ...incomingMessage.data });
        }
        this.playAudio();
      });
    });
  }

  playAudio(): void {
    const audio = new Audio();
    audio.src = '../assets/ring_ring.mp3';
    audio.load();
    audio.play();
  }

  openOrderNotifyModal(order: any): void {
    this.ref = this.dialogService.open(OrderNotifyModalComponent, {
      header: 'Order Created',
      width: '30vw',
      height: '50%',
      modal: true,
      data: {
        order: order,
      },
    });
    this.ref.onClose.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: () => {},
    });
  }
}
